import React from 'react';
import { Card, Typography, Avatar } from 'antd';

const { Title, Text } = Typography;

interface WelcomeCardProps {
    avatarUrl?: string;
    name: string;
    title: string;
    message: string;
}

const WelcomeCard: React.FC<WelcomeCardProps> = ({
    avatarUrl = '',
    name,
    title,
    message,
}) => (
    <Card style={{ textAlign: 'center', borderRadius: 8 }}>
        <Avatar
            size={100}
            src={avatarUrl || 'https://via.placeholder.com/100'} // Replace with actual placeholder URL or fallback
            style={{ marginBottom: 16 }}
        />
        <Title level={5} style={{ marginBottom: 8 }}>
            {name}
        </Title>
        <Title level={5} style={{ marginBottom: 8 }}>
            {title}
        </Title>
        <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
            {message}
        </Text>
    </Card>
);

export default WelcomeCard;
